module.exports = __webpack_public_path__ + "static/img/KatiePhoto.55736fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/KatiePhoto.jpg
// module id = c/JP
// module chunks = 1